let counter = 0;

export const getUniqueElementId = name => {
  counter += 1;

  return `generated-id-${name}-${counter}`;
};
